import { useRef, type PointerEvent } from "react";

/** How far (px) the pointer may travel between down and up and still click. */
const DRAG_TOLERANCE_PX = 4;

/**
 * Tells a real click from the mouse-up that ends a pan of the zoomable image
 * the element sits on. Spread `onPointerDown` on the element(s) and check
 * `isClick(e)` in their onClick; one instance can serve a list of elements.
 */
export const useClickWithoutDrag = () => {
  const downRef = useRef<{ x: number; y: number } | null>(null);
  return {
    onPointerDown: (e: PointerEvent) => {
      downRef.current = { x: e.clientX, y: e.clientY };
    },
    isClick: (e: { clientX: number; clientY: number }) => {
      const down = downRef.current;
      downRef.current = null;
      return (
        !down ||
        Math.hypot(e.clientX - down.x, e.clientY - down.y) <= DRAG_TOLERANCE_PX
      );
    },
  };
};
